export enum FreeTextKey {
  Title = 'titleText',
  Subtitle = 'subtitleText',
  NoItemsMessage = 'noItemsMessage',
  NoItemsInfo = 'noItemsInfo',
}

export type FreeText = {
  [key in FreeTextKey]?: string;
};
